export default __webpack_public_path__ + "static/media/lead.8e1d09f4.jpeg";